// async bootstrap of this component

import type { IRootThemedComponentProps } from './async-root-themed-component';

function MountRootThemedComponent(props: IRootThemedComponentProps, el: Element) {
	if (!window.ComponentsToMount?.length) return;
	import('./async-root-themed-component')
		.then(a => a.MountRootThemedComponent(props, el))
		.catch(error => {
			console.error('Unable to load page components', error);
			const message = document.createElement('p');
			message.setAttribute('role', 'alert');
			message.textContent = 'Interactive content could not load. ';
			const retry = document.createElement('button');
			retry.type = 'button';
			retry.textContent = 'Retry';
			retry.addEventListener('click', () => {
				el.replaceChildren();
				MountRootThemedComponent(props, el);
			});
			message.append(retry);
			el.replaceChildren(message);
		});
}

window.MountRootThemedComponent = MountRootThemedComponent;
